const DEFAULT_LOCALE = 'en';

export const formatNumber = (value: number, options?: Intl.NumberFormatOptions): string => {
  try {
    return new Intl.NumberFormat(DEFAULT_LOCALE, options).format(value);
  } catch {
    return value?.toString();
  }
};
